import { AxiosBaseResponse } from '@/types/common';
import { TWizardResponse } from '@/lib/services/wizard';

export const TProjectStatus = {
  ACTIVE: 'Active',
  IN_PROGRESS: 'In progress',
  CLOSED: 'Closed',
} as const;

export type TProjectStatus =
  (typeof TProjectStatus)[keyof typeof TProjectStatus];

export interface TProject {
  id: string;
  name: string;
  site_url: string;
  created?: string;
  description?: string;
  contact?: string;
  marker?: string;
  status?: TProjectStatus;
  totalPosts?: number;
  has_brand_strategy?: boolean;
  has_ideas?: boolean;
  has_posts?: boolean;
}

export interface GetProjectsResponse extends Partial<AxiosBaseResponse> {
  data: TProject[];
}

export interface UpdateProjectsResponse extends Partial<AxiosBaseResponse> {
  data: TProject;
}

export interface ProjectWizardResponse extends Partial<AxiosBaseResponse> {
  data: TWizardResponse;
}

export interface StartProjectRequest {
  projectId: string;
  data: { websiteLink: string };
}

export interface StartProjectSuccessResponse {
  status: 'success';
  data: {
    task: {
      id: string;
      status: 'success';
    };
  };
}
